export function calcWidth(w, h) {
  return w > 100 || w > h ? 100 : Math.ceil((w * 100) / h)
}

export function calcHeight(w, h) {
  return h > 100 || h > w ? 100 : Math.ceil((h * 100) / w)
}



// WEBPACK FOOTER //
// ./src/utils/dimensions.js